import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Container, Button, Grid, Paper } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import {
    AgentOnboard as AGENT_ONBOARDING,
} from 'Components/Api/EzyPayAEPSAPI';
import { FetchDetailsForPincode as FETCH_DETAILS_FOR_PINCODE } from 'Components/Api/UsersApi';
import CircularProgress from '@material-ui/core/CircularProgress';
import HOCLoader from 'Components/Loader/HOCLoader';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { GetFingerPrint } from 'Components/FingerPrintProcessing';
import { SelectProfile as USER_SELECT_BY_ID } from 'Components/Api/UsersApi';
import {
    PLEASE_PROVIDE_VALID,
} from 'Components/Helper/Messages';
import Box from '@material-ui/core/Box';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import usePosition from 'Components/Posistion';
const CustomContainer = HOCLoader(Container);
export const EPayOnboardingForAirtel = () => {
    const history = useHistory();
    const classes = commonStyle();
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [status, setStatus] = useState('PROCESS');
    const [Message, setMessage] = useState('');
    const { latitude, longitude } = usePosition();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [formObject, setFormObject] = useState({
        AadhaarNo: '',
        MobileNo: '',
        PinCode: '',
        Address: '',
        City: '',
        State: 1,
        AccountNumber: '',
        IFSCCode: '',
        Latitude: latitude,
        Longitude: longitude
    });
    useEffect(() => {
        setLoading(true);
        SelectByID();
    }, [latitude]);
    const SelectByID = async () => {
        setLoading(true);
        const { isAuthorized, status, data } = await USER_SELECT_BY_ID();
        setLoading(false);

        if (!isAuthorized) LOGOUT();

        if (!status) return;

        var d = JSON.parse(data);

        setFormObject({
            ...formObject,
            PanNo: d.PANNo,
            AadhaarNo: d.AadharNo,
            MobileNo: d.MobileNumber,
            City: d.City,
            Address: d.Address,
            PinCode: d.PinCode
        });
    };
    const FormValidationSchema = Yup.object({
        AadhaarNo: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'AadharNumber'
        ),
    });
    const submitHandle = async (values, { resetForm }) => {
        setIsError(false);
        setLoading(true);
        setResponseMessage('');
        setLoadingOpen(true);
        const { status, xmldata } = await GetFingerPrint('');
        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;

        var inputObj = {
            AadharCard: values.AadhaarNo,
            Mobile: values.ConsumerNumber,
            FingerPrint: fingerPrintXML,
            Latitude: latitude,
            Longitude: longitude,
        };
        var requestObj = JSON.stringify(inputObj);
        var response = await AGENT_ONBOARDING(requestObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setSeverity('success');
        if (response.data) {
            setSeverity('error');
            setResponseMessage(response.data);
            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            return;
        }
        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        if (data.Status === 'SUCCESS') {
            history.push('/EPayAEPS');
            return;
        }
    };
    const FetchDetails = async (values, setFieldValue) => {
        var request = {
            PinCode: values.PinCode
        };
        var requestObj = JSON.stringify(request);
        setLoading(true);
        setIsError(false);
        var response = await FETCH_DETAILS_FOR_PINCODE(requestObj);
        if (!response.isAuthorized) LOGOUT();

        setLoading(false);
        setIsError(true);
        setSeverity('success');

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
            return;
        }
        var data = JSON.parse(response.data);
        setFieldValue('Address', data.CityName);
        setFieldValue('City', data.District);
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
                render={({ values, errors, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={1}
                        >
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        User Onborad :: Latitude: {latitude}, Longitude:{longitude}
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="Aadhaar No"
                                                        name="AadhaarNo"
                                                        type="text"
                                                        length={12}
                                                        placeholder="Aadhaar Number"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile No"
                                                        name="MobileNo"
                                                        type="text"
                                                        length={10}
                                                        placeholder="Mobile Number"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="City"
                                                        name="City"
                                                        type="text"
                                                        icon="shop"
                                                        title="City"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Register"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Register
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />

            {isAlertErrorOpen && (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            )}
        </CustomContainer>
    );
};
